import { createContext } from "react";

interface WsContextType {
  sendMessage: () => void;
  addListener: (deviceId: string, fn: (event: MessageEvent) => void) => void;
}

export const WsContext = createContext<WsContextType | null>(null);
